import * as React from 'react';
import Animated, { interpolateColor, useAnimatedStyle } from 'react-native-reanimated';
import { rem } from 'design-system';
import SelectorControllableReanimated from 'design-system/SelectorControllableReanimated';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { InvestWalkthroughContext } from 'features/feed/components/walkthrough/context';
import { isWeb } from '../../../constants';
const DiscoverSecclHeaderExtension = ({ scrollX, scrollY, secclHorizontalScrollViewRef, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const isInInvestWalkthrough = React.useContext(InvestWalkthroughContext);
    const { width, contentWidth } = useAppFrameDimensions(isWeb);
    const usableWidth = width - rem(32) - rem(8);
    const sections = React.useMemo(() => [
        { name: 'Ready-made', width: usableWidth / 2 },
        { name: 'Do it yourself', width: usableWidth / 2 },
    ].map((item) => ({
        ...item,
        id: item.name,
        text: item.name,
        color: colors.buttons.brandLight,
    })), [usableWidth, colors.buttons.brandLight]);
    const setSelection = React.useCallback((index) => {
        secclHorizontalScrollViewRef.current?.scrollTo({
            x: index * contentWidth,
            animated: true,
        });
    }, [secclHorizontalScrollViewRef, contentWidth]);
    const animatedContainerStyles = useAnimatedStyle(() => ({
        backgroundColor: interpolateColor(scrollY.value, [0, 40], [
            colors.cards.onDark,
            colors.background.dark,
        ]),
    }));
    return (<Animated.View style={[styles.container, isInInvestWalkthrough && styles.investWalkthroughStyles, animatedContainerStyles]}>
      <SelectorControllableReanimated scrollX={scrollX} spaceBetween={0} sections={sections} screenWidth={contentWidth} setSelection={setSelection} itemStyle={styles.itemStyle} style={styles.selectorContainer} selectorStyle={styles.selectorStyle}/>
    </Animated.View>);
};
export default React.memo(DiscoverSecclHeaderExtension);
const styleSet = createStyleSheets(() => ({
    container: {
        padding: rem(4),
        borderRadius: rem(28),
        marginVertical: rem(8),
        marginHorizontal: rem(16),
    },
    investWalkthroughStyles: {
        marginVertical: rem(4),
        marginHorizontal: rem(4),
    },
    itemStyle: {
        height: rem(36),
        paddingVertical: 0,
    },
    selectorStyle: {
        margin: 0,
        padding: 0,
        height: rem(36),
        borderRadius: rem(28),
    },
    selectorContainer: {
        paddingVertical: 0,
    },
}));
